import React, { createContext, useState, useEffect } from 'react';
import api from '../services/api';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [usuario, setUsuario] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      verificarToken();
    } else {
      setLoading(false);
    }
  }, []);

  const verificarToken = async () => {
    try {
      const response = await api.get('/auth/verificar');
      if (response.data.success) {
        setUsuario(response.data.usuario);
        localStorage.setItem('usuario', JSON.stringify(response.data.usuario));
      }
    } catch (error) {
      localStorage.removeItem('token');
      localStorage.removeItem('usuario');
    } finally {
      setLoading(false);
    }
  };

  const login = async (email, password) => {
    try {
      console.log('🔐 Intentando login con:', email);
      const response = await api.post('/auth/login', { email, password });
      console.log('✅ Respuesta del servidor:', response.data);
      
      if (response.data.success) {
        localStorage.setItem('token', response.data.token);
        localStorage.setItem('usuario', JSON.stringify(response.data.usuario));
        setUsuario(response.data.usuario);
        console.log('✅ Login exitoso, usuario guardado:', response.data.usuario);
        return { success: true };
      } else {
        console.log('❌ Login falló:', response.data.message);
        return {
          success: false,
          message: response.data.message || 'Error al iniciar sesión'
        };
      }
    } catch (error) {
      console.error('❌ Error en login:', error);
      console.error('Error completo:', {
        message: error.message,
        code: error.code,
        response: error.response?.data,
        status: error.response?.status
      });
      
      // Manejar diferentes tipos de errores
      if (error.code === 'ECONNREFUSED' || error.message?.includes('Network Error') || error.message?.includes('Failed to fetch')) {
        return {
          success: false,
          message: 'No se puede conectar al servidor. Verifica que el backend esté corriendo en el puerto 5000.'
        };
      }
      
      if (error.response) {
        // El servidor respondió con un código de error
        console.log('Respuesta de error del servidor:', error.response.data);
        return {
          success: false,
          message: error.response.data?.message || 'Error al iniciar sesión'
        };
      }
      
      // Error de red u otro error
      return {
        success: false,
        message: error.message || 'Error al iniciar sesión. Verifica tu conexión.'
      };
    }
  };

  const registro = async (datos) => {
    try {
      const response = await api.post('/auth/registro', datos);
      if (response.data.success) {
        localStorage.setItem('token', response.data.token);
        localStorage.setItem('usuario', JSON.stringify(response.data.usuario));
        setUsuario(response.data.usuario);
        return { success: true };
      }
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Error al registrar usuario'
      };
    }
  };

  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('usuario');
    setUsuario(null);
  };

  return (
    <AuthContext.Provider value={{ usuario, loading, login, registro, logout, verificarToken }}>
      {children}
    </AuthContext.Provider>
  );
};

